import { AlertTriangle, Search, HelpCircle, Euro } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const problems = [
  {
    icon: Search,
    title: "Recherche fastidieuse",
    description: "Passer des heures sur WhatsApp ou Facebook à chercher un transporteur fiable."
  },
  {
    icon: HelpCircle,
    title: "Manque de confiance",
    description: "Comment savoir si le transporteur est sérieux ? Pas de vérification, pas d'avis."
  },
  {
    icon: Euro,
    title: "Prix flous",
    description: "Des tarifs qui changent au dernier moment, des frais cachés."
  },
  {
    icon: AlertTriangle,
    title: "Risques élevés",
    description: "Colis perdus, retards non communiqués, aucun recours en cas de problème."
  }
];

const ProblemSection = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  
  return (
    <section id="probleme" className="py-12 md:py-20 bg-muted/50">
      <div ref={ref} className="container mx-auto px-4">
        {/* Header */}
        <div className={`text-center max-w-3xl mx-auto mb-8 md:mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3">
            Envoyer un colis au Maroc ?<br />
            <span className="text-destructive">Un vrai parcours du combattant.</span>
          </h2>
          <p className="text-base md:text-lg text-foreground font-medium italic">
            GoBledPro est né d'un constat simple : envoyer un colis entre la France et le Maroc ne devrait jamais être une source de stress, pourtant les frustrations sont réelles.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className={`group bg-card border border-border rounded-xl p-4 md:p-5 hover:border-destructive/50 hover:shadow-lg transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-destructive/10 flex items-center justify-center mb-3 group-hover:bg-destructive/20 transition-colors">
                <problem.icon className="w-5 h-5 md:w-6 md:h-6 text-destructive" />
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
                {problem.title}
              </h3>
              <p className="text-muted-foreground text-sm">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <div className={`mt-8 text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: '600ms' }}>
          <p className="text-base text-muted-foreground">
            <span className="font-semibold text-foreground">Résultat ?</span> Du stress, du temps perdu,
            et parfois des colis qui n'arrivent jamais.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
